import React, { useEffect,useState}from "react";
import { Grid, Tabs, Tab, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useThemeContext from "../../hooks/useThemeSwitch.js";
import { useFeatureFlag } from "../../hooks/useFeatureFlags";
import useHasPermissions from "../../hooks/useHasPermissions";
import { faCog, faUserPlus, faUsers } from "@fortawesome/pro-duotone-svg-icons";
import { setRootContainerWidth } from "../../reducers/layout/layoutReducer.js";
import { useStyles } from "./styles.js";
import OneParkAdminContainer from "../../components/OneParkAdmin/OneParkAdminContainer.jsx";
import OneParkAccountContainer from "../../components/OneParkAccount/OneParkAccountContainer.jsx"

const OneParkAdminPage = () => {
  const classes = useStyles();
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;
  const isOneParkEnabled = useFeatureFlag("ONEpark");
  const { hasPermissions } = useHasPermissions();
  const hasOneParkPermission = hasPermissions(["ONEparkAdmin"]);
  const canAccessOnePark = isOneParkEnabled && hasOneParkPermission;
  const[selectedTab, setSelectedTab] = useState("tabAccount")

 useEffect(() => {
    layoutDispatch({ type: setRootContainerWidth, payload: false });
  }, [layoutDispatch]);

  const handleTabChange = (event, newValue) =>{
    setSelectedTab(newValue);
  }

  return (
    <>
      {canAccessOnePark && (
        <>
          <Grid item xs={12}>
            <Tabs
              centered
              className={classes.oneParkTab}
              variant="fullWidth"
              value={selectedTab}
              onChange={handleTabChange}
            >
              <Tab
                value="tabAccount"
                icon={<FontAwesomeIcon icon={faUsers} size="2xl" />}
                label="Account"
                data-testid="onepark-account-tab"
              />
              <Tab
                value="tabAdmin"
                icon={<FontAwesomeIcon icon={faCog} size="2xl" />}
                label="Admin"
                data-testid="onepark-admin-tab"
              />
            </Tabs>
          </Grid>
          
          {selectedTab === "tabAccount" && (
            <Grid item xs={12}>
              <OneParkAccountContainer />
            </Grid>
          )}
         {selectedTab === "tabAdmin" && (     
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.subHeader}>
                ONEpark Admin
              </Typography>
              <OneParkAdminContainer />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default OneParkAdminPage;
